import dayjs from "dayjs";
import {
  CopyCalanderParams,
  CopyCalanderRequest,
  CopyItemForSave,
  CopyTypeKey,
} from "us.collection.admin/interfaces";

export function buildCopyCalanderParams(input: {
  selectedTypes: Record<CopyTypeKey, boolean>;
  isRecurring: boolean;
  currentYear: number;
}): CopyCalanderParams {
  return {
    isNonSMSDay: !!input.selectedTypes.nonSms,
    isNonPrintDay: !!input.selectedTypes.nonPrinting,
    isNonEmailDay: !!input.selectedTypes.nonEmail,
    isNonEhfDay: !!input.selectedTypes.nonEhf,
    isRecurring: !!input.isRecurring,
    currentYear: input.currentYear,
  };
}

export function mapCopyItemToCopyCalanderRequest(
  item: CopyItemForSave,
): CopyCalanderRequest {
  return {
    id: typeof item.id === "number" ? item.id : -1,
    startDate: item.startDate,
    endDate: item.endDate,
    reason: item.reason,
    isNonSMSDay: !!item.types.nonSms,
    isNonPrintDay: !!item.types.nonPrinting,
    isNonEmailDay: !!item.types.nonEmail,
    isNonEhfDay: !!item.types.nonEhf,
    isRecurring: !!item.isRecurring,
    status: typeof item.status === "number" ? item.status : 0,
  };
}
